import styled from 'styled-components'
import {
  TextInput,
} from '@usap/uicomponents'

const TextInputWithEllipsis = styled(TextInput)`
  width: calc(100% - 24px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  &:focus {
    box-shadow: none;
  }
`
export default TextInputWithEllipsis
